<div style="padding: 20px">
  <h4>Are you sure to delete buyer choice?</h4>
  <div style="width: 100%; display: flex; justify-content: space-between">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button (click)="deleteBuyerChoice()" style="background: #be0000; color: #fff">Unlink</button>
  </div>
</div>
